import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'iKominiarz.pl – Znajdź sprawdzonego kominiarza w Polsce',
  description = 'iKominiarz.pl to platforma do szybkiego znalezienia sprawdzonego kominiarza, umawiania wizyt, kontaktu i opinii. Zweryfikowani specjaliści z całej Polski.',
  keywords = 'kominiarz, usługi kominiarskie, czyszczenie komina, przegląd kominiarski, kominiarz Warszawa, kominiarz Kraków, znaleźć kominiarza',
  image = '/chimney-hero.png',
  url = 'https://ikominiarz.pl',
  type = 'website',
  structuredData = null,
}) => {
  const fullTitle = title.includes('iKominiarz.pl') ? title : `${title} | iKominiarz.pl`;
  const fullImage = image.startsWith('http') ? image : `${url}${image}`;

  return (
    <Helmet>
      {/* Podstawowe meta tagi */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="iKominiarz.pl" />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content="iKominiarz.pl" />
      <meta property="og:locale" content="pl_PL" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />

      {/* Structured Data (JSON-LD) */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
